import http from "@/http"

const HRPersonelRequestService = {

    getAllAndGetByMailByMailService: async (form) => {
      const all = await http.instance.get("HR/Personel/GetAllAndGetById", {params: { UserId: form.userId }})
        return all;
    },

    getHRPersonelByIdService: async (id) => {
        const personByID = await http.instance.get("HR/Personel/GetPersonalDocumentsByIdVer2",{params:{PersonelId:id}});
        return personByID;
    },

    getCvlType: async ()  => {
      const cvl = await http.instance.get("HR/Personel/GetCVLTypes");
      return cvl;
    },

    getCountries: async () => {
        const countries = await http.instance.get("HR/Personel/GetCountries");
        return countries;
    },

    getPersonelPassportReport: async (info) => {
        const passportsAll = await http.instance.get("HR/Personel/GetPersonelPassportReport",  {params: { UserId: info.userId }});
        return passportsAll;
    },

    getPersonelPassportPdf: async (info) => {
        console.log(info)
        const passportsAll = await http.instance.get("HR/Personel/ExportPdfPassport",  {params: { Id:info.userId, Email:info.email, generalFilter:info.search, tlcFilter: info.searchTlc}});
        return passportsAll;
    },

    getUsersWithPerms: async () => {
      const perm = await http.instance.get("HR/PersonelPermManagement/GetUsersWithPerms");
      return perm;
    },

    getDistinctedPositions: async () => {
        const dist = await http.instance.get("HR/PersonelPermManagement/GetDistinctedPositions");
        return dist;
    },

    addPermSelectedUser: async (form) => {
      const perm = await http.instance.get("HR/PersonelPermManagement/AddPermSelectedUser", {params:{UserId: form.UserId, ShortCode: form.ShortCode}});
      return perm;
    },

    deletePermSelectedUser: async (form) => {
      const perm = await http.instance.get("HR/PersonelPermManagement/DeletePermSelectedUser", {params:{UserId:form.id, ShortCode: form.code}});
      return perm;
    },

    InsertOrUpdatePersonService: async (PI) => {
        const person = await http.instance.post("HR/Personel/InsertOrUpdatePerson", PI);
        return person;
    },
    UploadMedicalCheckInformationService: async (form) => {
        const Files = new FormData();
        Files.append("Files", form.files);
      const mc = await http.instance.post("HR/Personel/UploadMedicalCheckInformationVer3", Files, {
          headers: {'Content-Type': 'multipart/form-data'},
          params: {
              DocumentId: form.DocumentId,
              DocumentIndeksNo: form.DocumentIndeksNo,
              PersonelID: form.PersonelID,
              MEDCTYPE: form.MEDCTYPE,
              LVO: form.LVO,
              OML: form.OML,
              DATE_OF_ISSUE: form.DATE_OF_ISSUE,
              DATE_OF_EXPIRY: form.DATE_OF_EXPIRY,
              CVLTypes: form.CVLTypes,
              CompanyCode: form.CompanyCode,
              Nefa_Employee_Id: form.Nefa_Employee_Id,
              CVL_DESCRIPTION: form.CVL_DESCRIPTION,
              LICENCE_TYPE: form.LICENCE_TYPE,
              LICENCE_NO: form.LICENCE_NO,
          }
      });
      return mc;
    },
    UploadLandingInformationService: async (form) => {
        const Files = new FormData();
        Files.append("Files", form.files);
        const mc = await http.instance.post("HR/Personel/UploadLandingInformationVer2", Files, {
            headers: {'Content-Type': 'multipart/form-data'},
            params: {
                DocumentId: form.DocumentId,
                PersonelID: form.PersonelID,
                DocumentIndeksNo: form.DocumentIndeksNo,
                CompanyCode: form.CompanyCode,
                Nefa_Employee_Id: form.Nefa_Employee_Id,
                ExpiryDate: form.ExpiryDate,
            }
        });
        return mc;
    },
    UploadVisaInformationService: async (form) => {
        const Files = new FormData();
        Files.append("Files", form.files);
      const vi = await http.instance.post("HR/Personel/UploadVisaInformationVer2", Files,{
          headers: {'Content-Type': 'multipart/form-data'},
          params: {
              DocumentId: form.DocumentId,
              DocumentIndeksNo: form.DocumentIndeksNo,
              PersonelID: form.PersonelID,
              PassaportNumber: form.PassaportNumber,
              VisaNumber: form.VisaNumber,
              DateOfIssue: form.DateOfIssue,
              CountryOfIssue: form.CountryOfIssue,
              PlaceOfIssue: form.PlaceOfIssue,
              DateOfExpiry: form.DateOfExpiry,
              CompanyCode: form.CompanyCode,
              Nefa_Employee_Id: form.Nefa_Employee_Id
          }
      });
      return vi;
    },
    UploadPassaportService: async (form) => {
        const Files = new FormData();
        Files.append("Files", form.files);
      const pi = await http.instance.post("HR/Personel/UploadPassaportVer2", Files,{
          headers: {'Content-Type': 'multipart/form-data'},
          params: {
              DocumentId: form.DocumentId,
              DocumentIndeksNo: form.DocumentIndeksNo,
              PersonelID: form.PersonelID,
              DocumentNumber: form.DocumentNumber,
              DateOfIssue: form.DateOfIssue,
              CountryOfIssue: form.CountryOfIssue,
              PlaceOfIssue: form.PlaceOfIssue,
              DateOfExpiry: form.DateOfExpiry,
              CompanyCode: form.CompanyCode,
              Nefa_Employee_Id: form.Nefa_Employee_Id,
              Nationality: form.Nationality
          }
      });
      return pi;
    },
    UploadLicenceInformationService: async (form) => {
        const Files = new FormData();
        Files.append("Files", form.files);
        //console.log(form)
      const li = await http.instance.post("HR/Personel/UploadLicenceInformationVer3", Files, {
          headers: {'Content-Type': 'multipart/form-data'},
          params: {
              DocumentId: form.DocumentId,
              DocumentIndeksNo: form.DocumentIndeksNo,
              PersonelID: form.PersonelID,
              LicenseType: form.LicenseType == null ? '' : form.LicenseType,
              LicenseNumber: form.LicenseNumber == null ? '' : form.LicenseNumber,
              Authority: form.Authority == null ? '' : form.Authority,
              Issue_Country: form.Issue_Country == null ? '' : form.Issue_Country,
              License_Expiry: form.License_Expiry == "" ? '1900-01-01' : form.License_Expiry,
              ExaminerLicenseNR: form.ExaminerLicenseNR == null ? '' : form.ExaminerLicenseExpiry,
              ExaminerLicenseExpiry: form.ExaminerLicenseExpiry == "" ? '1900-01-01' : form.ExaminerLicenseExpiry,
              CompanyCode: form.CompanyCode == null ? '' : form.CompanyCode,
              Nefa_Employee_Id: form.Nefa_Employee_Id,
              RATING_CERTIFICATE: form.RATING_CERTIFICATE == null ? '' : form.RATING_CERTIFICATE,
              LICENCE_TITLE: form.LICENCE_TITLE == null ? '' : form.LICENCE_TITLE,
              LANGUAGE_1: form.LANGUAGE_1 == null ? '' : form.LANGUAGE_1,
              LANGUAGE_1_LEVEL: form.LANGUAGE_1_LEVEL == null ? '' : form.LANGUAGE_1_LEVEL,
              LANGUAGE_1_DATE: form.LANGUAGE_1_DATE == "" ? '1900-01-01' : form.LANGUAGE_1_DATE,
              LANGUAGE_2: form.LANGUAGE_2 == null ? '' : form.LANGUAGE_2,
              LANGUAGE_2_LEVEL: form.LANGUAGE_2_LEVEL == null ? '' : form.LANGUAGE_2_LEVEL,
              LANGUAGE_2_DATE: form.LANGUAGE_2_DATE == "" ? '1900-01-01' : form.LANGUAGE_2_DATE,
          }
      });
      return li;
    },

    DeleteHRPersonelService: async (personelId) => {
        const person = await http.instance.get("HR/Personel/Delete", {params:{personelId:personelId}});
        return person;
    },

    DeleteDocumentAttachmentsService: async(form) => {
      const doc = await http.instance.get("HR/Personel/DeleteDocumentAttachments", { params:{DocumentId: form.documentTypeID, DocumentType: form.documentTypeIndex, DocumentIndeksNo: form.documentIndeksNo} });
      return doc;
    },

    DeleteDocumentService: async (form) => {
        const person = await http.instance.get("HR/Personel/DeleteDocument", {params:{DocumentId:form.Document_P_ID, DocumentType:form.documentTypeIndex}});
        return person;
    }


}

export default HRPersonelRequestService
